<lib-version-update [swUpdateInterval]="600000"></lib-version-update>
<lib-maintenance></lib-maintenance>
<lib-offline></lib-offline>
<div class="h-full bg-white md:bg-grey-light-concrete overflow-y-auto">
  <div class="mx-auto flex min-h-screen w-full md:items-center justify-center md:px-4 md:py-6">
    <div class="w-full md:max-w-[980px]">
      <app-login-container class="mx-auto flex justify-center"></app-login-container>
      <app-footer class="my-2 text-center text-xs text-grey-mid"></app-footer>
    </div>
  </div>
</div>
